$(function () {
    $('body').on('click', '#UserEdit .radio-area .radio', function() {
        const dataValue = $(this).data('value');
        $('#UserEdit .radio-area .radio').removeClass('active')
        $(this).addClass('active')
        $('#UserEdit #edit_gym_user #gym_user_sex').val(dataValue);
    });
    const sexValue = $('#UserEdit #edit_gym_user #gym_user_sex').val();
    $(`#UserEdit .radio-area .radio[data-value="${sexValue}"]`).addClass('active')
});
